import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";

import EmployeeDocuments from "./index";
import { FileText } from "lucide-react";
import { MODULE_MY_DOCS } from "variables/constants";

const employeeDocumentsRoutes = [	
    generateCRUDRoutes({
        mainTitle: "My Documents",
        basePath: "documents",
        mainComponent: <EmployeeDocuments />,
        layout: "/console",
        icon: <FileText className="icon-item" />,
        subTitle:"My Document",
        level:5,
        moduleId: MODULE_MY_DOCS,
    })
];

export default employeeDocumentsRoutes;